// Links públicos de la navegación de la web. Esto podría obtenerse desde una request o desde una cookie o similar.
export default [...config.WEB_LINKS];
